import { connect } from 'react-redux';
import StripeDetailForm from '../components/StripeDetailForm';
import { getMemberType } from '../selectors/converterSelector';
import {
    requestInfo,
    submitPayFastInformation,
    submitStripeInformation,
} from '../actions/userActions';
import { getUserFullInfo } from '../selectors/userSelector';
import { requestPayFastMissingFields, requestStripeMissingFields } from '../actions/user/stripe';

const mapStateToProps = function(store) {
    return {
        isLoading: store.user.isLoading,
        initialized: store.user.initialized,
        memberType: getMemberType(store),
        userInfo: getUserFullInfo(store.user.info, store.address.list), // IMPORTANT: This will always display the currently logged in user
        stripeFieldData: store.user.stripeFieldData,
        stripeConnectRequired: store.user.stripeConnectRequired,
        stripeConnectCompleted: store.user.stripeConnectCompleted,
    };
};

const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        requestInfo: () => dispatch(requestInfo()),
        requestPayFastMissingFields: () => dispatch(requestPayFastMissingFields()),
        requestStripeMissingFields: () => dispatch(requestStripeMissingFields()),
        submitPayFastInformation: (formData, callback) => dispatch(submitPayFastInformation(formData, callback)),
        submitStripeInformation: (formData, callback) => dispatch(submitStripeInformation(formData, callback)),
    };
};
const ConnectedStripeDetailForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(StripeDetailForm);

export default ConnectedStripeDetailForm;
